import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RevertReservationsStatusComponent } from 'OpsCenter/merchants/revert-status/revert-reservations-status.component';
import { RevertReservationsStatusService } from 'OpsCenter/merchants/revert-status/revert-reservations-status.service';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'app/merchants-revert-reservations-status', component: RevertReservationsStatusComponent },
    ]),
  ],
  providers: [RevertReservationsStatusService],
  declarations: [RevertReservationsStatusComponent],
})
export default class RevertStatusModule {}



// WEBPACK FOOTER //
// ./src/app/merchants/revert-status/revert-status.module.ts